(() => {
  if (customElements.get("product-form")) return;

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector(".js-product-form");
      if (!this.form) return;

      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      this.cartDrawer = document.querySelector("cart-drawer") || null;
      this.submitBtn = this.querySelector('[name="add"]');

      if (!this.submitBtn) return;

      if (window.theme && theme.settings && theme.settings.afterAtc !== "no-js") {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
      }
    }

    async handleSubmit(e) {
      let addSucceeded = false;
      try {
        if (e && e.target && e.target.id === "product-signup_form") return;
        e.preventDefault();
        if (window.SLIDECART_STATE().settings.enabled) return;

        if (this.submitBtn.getAttribute("aria-disabled") === "true") return;

        if (theme?.settings?.vibrateOnATC && window.navigator.vibrate) {
          window.navigator.vibrate(100);
        }

        this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
        this.setErrorMsgState(false);

        this.submitBtn.setAttribute("aria-disabled", "true");
        this.submitBtn.classList.add("is-loading");

        const formData = new FormData(this.form);

        let sections = "cart-icon-bubble";
        if (this.cartDrawer) {
          const sectionEl = this.cartDrawer.closest(".shopify-section");
          if (sectionEl && sectionEl.id) {
            sections += `,${sectionEl.id.replace("shopify-section-", "")}`;
          }
        }

        formData.append("sections_url", window.location.pathname);
        formData.append("sections", sections);

        let beforeCart = null;
        try {
          const beforeRes = await fetch(`${theme.routes.cart}.js`, {
            credentials: "same-origin"
          });
          if (beforeRes.ok) beforeCart = await beforeRes.json();
        } catch (cartError) {
          console.warn("Salt Shift: cart state before add was unavailable.", cartError);
        }

        const addRes = await fetch(theme.routes.cartAdd, {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
          credentials: "same-origin",
        });

        const addJson = await addRes.json();
        if (!addRes.ok || addJson?.status || addJson?.errors) {
          let msg = addJson?.description || addJson?.message || "Unable to add to cart.";
          if (addJson?.errors && typeof addJson.errors === "object") {
            msg = Object.entries(addJson.errors)
              .map(([, arr]) => (Array.isArray(arr) ? arr.join(", ") : String(arr)))
              .join("<br>");
          }
          this.setErrorMsgState(msg);
          throw new Error(`Cart add failed: ${addRes.status}`);
        }
        addSucceeded = true;

        if (theme?.settings?.afterAtc === "page") {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          ProductForm.updateCartIcon(addJson);

          const quickAddDrawer = this.closest("quick-add-drawer");
          if (quickAddDrawer && typeof quickAddDrawer.addedToCart === "function") {
            quickAddDrawer.addedToCart();
          }

          setTimeout(() => {
            if (this.cartDrawer && typeof this.cartDrawer.renderContents === "function") {
              this.cartDrawer.renderContents(addJson, !quickAddDrawer && theme.settings
                .afterAtc === "drawer");
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector("cart-items");
              if (cartItems) {
                if (cartItems.dataset.empty === "true") {
                  window.location.reload();
                } else if (typeof cartItems.refresh === "function") {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        let afterCart = null;
        try {
          const afterRes = await fetch(`${theme.routes.cart}.js`, {
            credentials: "same-origin"
          });
          if (afterRes.ok) afterCart = await afterRes.json();
        } catch (cartError) {
          console.warn("Salt Shift: cart state after add was unavailable.", cartError);
        }

        const variantId = addJson.variant_id;
        const beforeLine = beforeCart?.items?.find((i) => i.variant_id === variantId);

        if (beforeLine) {
          this.dispatchEvent(
            new CustomEvent("on:line-item:change", {
              bubbles: true,
              detail: {
                cart: afterCart,
                variantId,
                oldQuantity: beforeLine.quantity,
                newQuantity: beforeLine.quantity === addJson.quantity ? beforeLine
                  .quantity : addJson.quantity,
              },
            })
          );
        } else {
          this.dispatchEvent(
            new CustomEvent("on:cart:add", {
              bubbles: true,
              detail: {
                cart: afterCart,
                variantId
              },
            })
          );
        }
      } catch (err) {
        console.log(err);

        const errorText =
          (this.errorMsg && this.errorMsg.textContent) ||
          "There was a problem adding this item to cart.";

        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: true,
            detail: {
              error: errorText
            },
          })
        );
      } finally {
        if (this.submitBtn) {
          if (addSucceeded) this.submitBtn.classList.add("is-success");
          this.submitBtn.removeAttribute("aria-disabled");

          setTimeout(() => {
            this.submitBtn.classList.remove("is-loading");
            this.submitBtn.classList.remove("is-success");
          }, 1400);
        }
      }
    }

    static updateCartIcon(addJson) {
      const el = document.getElementById("cart-icon-bubble");
      if (el && addJson?.sections && addJson.sections["cart-icon-bubble"]) {
        el.innerHTML = addJson.sections["cart-icon-bubble"];
      }
    }

    setErrorMsgState(message = false) {
      this.errorMsg = this.errorMsg || this.querySelector(".js-form-error");
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !message;

      if (!message) return;

      this.errorMsg.innerHTML = "";
      const parts = Array.isArray(message) ? message : [message];

      parts.forEach((msg, idx) => {
        if (idx > 0) this.errorMsg.insertAdjacentHTML("beforeend", "<br>");
        if (typeof msg === "string" && msg.includes("<br>")) {
          this.errorMsg.insertAdjacentHTML("beforeend", msg);
        } else {
          this.errorMsg.insertAdjacentText("beforeend", String(msg));
        }
      });
    }
  }

  customElements.define("product-form", ProductForm);
})();
